// import employeeLogo from "../../images/employee.png";
// import jsPDF from "jspdf";
// import { RFTfeature } from "../features/RFTfeature";

// export const StockPrint = ({ search, items, state, val }) => {
//   let doc = new jsPDF();
//   jsPDF.autoTableSetDefaults({
//     theme: "plain",
//     headStyles: { fontStyle: "bold" },

//     margin: { left: 8, right: 8, bottom: 10 },
//     bodyStyles: { color: "rgba(0, 0, 0, 0.87)", fontStyle: "bold" },
//   });
//   let pageWidth =
//     doc.internal.pageSize.width || doc.internal.pageSize.getWidth();

//   let img = new Image();

//   let baseUrl = localStorage.getItem("base_url");

//   if (baseUrl == undefined || baseUrl == "" || baseUrl == null) {
//     let snapshot = employeeLogo;
//     img.src = snapshot;
//   } else {
//     let snapshot = localStorage.getItem("base_url");
//     img.src = snapshot;
//   }

//   doc.addImage(img, "png", 5, 5, 30, 30);

//   doc.setFontSize(18);
//   doc.setFontStyle("bold");
//   doc.text(localStorage.getItem("company"), 90, 22);
//   doc.setFontSize(26);
//   doc.text("REPORT DETAIL", 80, 35);

//   doc.setFontSize(12);
//   doc.setFontStyle("normal");

//   doc.text("From:", 150, 45);
//   doc.text(search.startDate, 165, 45);

//   doc.text("To:", 150, 55);
//   doc.text(search.endDate, 165, 55);

//   doc.setFontSize(14);
//   doc.setFontStyle("bold");

//   doc.setFontSize(12);
//   doc.text("SHOP", 21, 48);

//   doc.setFontStyle("normal");
//   doc.text(localStorage.getItem("company") || "", 20, 55);
//   doc.text(localStorage.getItem("address") || "", 20, 62);
//   doc.text(localStorage.getItem("phone") || "", 20, 69);
//   let rows = [];
//   let col = ["#", "Item", "Cost Price", "Sale Price", "Quantity"];

//   items.map((element, i) => {
//     let qty = parseFloat(element.quantity);
//     let itemQty = qty % 1 === 0 ? qty : qty.toFixed(3);
//     let decimal = itemQty - Math.floor(itemQty);

//     if (element.weightType == true) {
//       let weight =
//         parseFloat(element.weight) % 1 === 0
//           ? element.weight
//           : parseFloat(element.weight).toFixed(3);
//       let temp = [
//         i + 1,
//         element.name,
//         element.costPrice,
//         element.price,
//         weight,
//       ];
//       rows.push(temp);
//     } else {
//       if (RFTfeature() && element.unit == "Role") {
//         let temp = [
//           i + 1,
//           element.name,
//           element.costPrice,
//           element.price,
//           "Role " +
//             parseInt(element.quantity) +
//             ",  " +
//             "RFT " +
//             parseInt(decimal * 328),
//         ];
//         rows.push(temp);
//       } else {
//         let temp = [
//           i + 1,
//           element.name,
//           element.costPrice,
//           element.price,
//           itemQty,
//         ];
//         rows.push(temp);
//       }
//     }
//   });

//   doc.autoTable(col, rows, { startY: 100 });
//   var finalY = doc.lastAutoTable.finalY;
//   doc.setFontSize(14);
//   doc.text("Total Stock Value", 125, finalY + 15);
//   doc.text(val.toString() || "", 168, finalY + 15);
//   doc.setFontSize(10);

//   doc.text("Powered by www.hardwarepakistan.com", pageWidth / 2, 285, {
//     align: "center",
//   });
//   doc.text("0342-5588269", pageWidth / 2, 290, {
//     align: "center",
//   });

//   if (window.innerWidth <= 600) {
//     doc.save("reciept");
//   } else {
//     doc.autoPrint();
//     window.open(doc.output("bloburl"), "_blank");
//   }
// };

import employeeLogo from "../../images/employee.png";
import { RFTfeature } from "../features/RFTfeature";
import html2pdf from "html2pdf.js";

export const StockPrint = ({ search, items, state, val }) => {
  // Create HTML content for the PDF
  console.log("itme", items);
  const htmlContent = document.createElement("div");

  htmlContent.innerHTML = `
    <div style="padding: 10px; font-family: Arial, sans-serif;">
      <div style="display: flex; align-items: center;">
        <img src="${
          localStorage.getItem("base_url") || employeeLogo
        }" width="30" height="30" style="margin-right: 10px;" />
        <h2>${localStorage.getItem("company")}</h2>
      </div>
      <h1 style="text-align: center;">STOCK REPORT</h1>

      <p>From: ${search.startDate}</p>
      <p>To: ${search.endDate}</p>

      <h3>SHOP</h3>
      <p>${localStorage.getItem("company") || ""}</p>
      <p>${localStorage.getItem("address") || ""}</p>
      <p>${localStorage.getItem("phone") || ""}</p>

     <table border="1" cellpadding="5" cellspacing="0" width="100%" style="margin-top: 20px;">
  <thead>
    <tr>
      <th>#</th>
      <th>Item</th>
      <th>Cost Price</th>
      <th>Sale Price</th>
      <th>Quantity</th>
      <th>Total Boxes</th>
      <th>Stock Value</th>
      

    </tr>
  </thead>
  <tbody>
    ${items
      .map((element, i) => {
        let qty = parseFloat(element.quantity);
        let itemQty = qty % 1 === 0 ? qty : qty.toFixed(3);
        let decimal = itemQty - Math.floor(itemQty);
        const costPriceBatchInside =
          element?.batchNumber?.[0]?.newItem?.costPrice ?? null;
        const salePriceBatchInside =
          element?.batchNumber?.[0]?.newItem?.price ?? null;
        let quantityDisplay = "";
        if (element.weightType) {
          quantityDisplay =
            parseFloat(element.weight) % 1 === 0
              ? element.weight
              : parseFloat(element.weight).toFixed(3);
        } else {
          if (RFTfeature() && element.unit === "Role") {
            quantityDisplay = `Role ${parseInt(
              element.quantity
            )}, RFT ${parseInt(decimal * 328)}`;
          } else {
            quantityDisplay = itemQty;
          }
        }

        let batchRows = "";
        if (element?.batchNumber?.length > 0) {
          batchRows = element.batchNumber
            .map((batch) => {
              let number = 0;

              return `
                <tr>
                  <td colspan="2">Batch #${batch?.batchNumber}</td> 
                  <td>${batch?.newItem?.costPrice || "N/A"}</td>
                  <td>${batch?.newItem?.price || "N/A"}</td>
                  <td>${batch?.quantity || 0}</td>
                  <td>${batch?.totalBoxes  || "N/A"}</td>

                  <td></td>

                </tr>
              `;
            })
            .join("");
        }

        return `
          <tr>
            <td>${i + 1}</td>
            <td>${element.name}</td>
            <td>${
              Number(element.pricePerPiece || element.costPrice || costPriceBatchInside)  % 2 == 0 ?  Number(element.pricePerPiece || element.costPrice || costPriceBatchInside)  :  Number(element.pricePerPiece || element.costPrice || costPriceBatchInside).toFixed(2)
            }</td>
            <td>${Number(element.price || salePriceBatchInside) % 2 == 0 ? Number(element.price || salePriceBatchInside) :  Number(element.price || salePriceBatchInside).toFixed(2)}</td>
            <td>${quantityDisplay}</td>
             <td>${element?.totalBoxes || "N/A"}</td>

              <td>${element.itemStockValue.toFixed(2)}</td>

          </tr>
          ${batchRows} <!-- Append batch rows -->
        `;
      })
      .join("")}
  </tbody>
</table>


      <p style="text-align: right; font-size: 14px; margin-top: 10px;">
        Total Stock Value: ${val || ""}
      </p>

    </div>
  `;

  const options = {
    margin: 0.5,
    filename: "stock_report.pdf",
    image: { type: "png", quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: "in", format: "a4", orientation: "portrait" },
  };

  // Generate PDF and open in a new tab with print preview
  html2pdf()
    .from(htmlContent)
    .set(options)
    .output("blob")
    .then((blob) => {
      const url = URL.createObjectURL(blob);
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = function () {
          setTimeout(() => {
            newWindow.print();
          }, 100); // Wait a short moment before printing
        };
      } else {
        alert("Please allow popups for this website");
      }
    });
};
